var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#171D38",
    d: "m16.25 15.75-3.257-3.257m0 0a6 6 0 1 0-8.485-8.485 6 6 0 0 0 8.485 8.485Z"
  })));
};
export default SvgSearch;